// Vendor
import { computed } from 'vue';

// Stores
import { useUiStore } from 'src/stores/ui';

// Personal libs
import {
  IAugmentedVideo,
  IProgram,
  IVideo,
} from '@shared/interface/model.interface';

export function useStorageVM() {
  // Init stores
  const uiStore = useUiStore();

  /**
   * Computed properties
   */
  const cachedVideoList = computed<Array<IVideo>>(
    () => uiStore.cachedVideoList ?? [],
  );
  const programs = computed<IProgram[]>(() => uiStore.programs ?? []);
  const videoList = computed<IAugmentedVideo[]>(() => {
    const tempArray: IAugmentedVideo[] = [];
    programs.value
      .filter((program) => program.videos != null && program.videos.length > 0)
      .forEach((program) => {
        program.videos.forEach((video) => {
          if (
            video.id != null &&
            cachedVideoList.value.some((v) => v.id === video.id)
          ) {
            const tempVideo = cachedVideoList.value.find(
              (v) => v.id === video.id,
            );
            if (tempVideo != null) {
              const tempData: IAugmentedVideo = {
                video: Object.assign(video, tempVideo),
                program,
              };
              tempData.video.fileSize =
                (tempVideo.fileSize ?? 0) > (tempData.video.fileSize ?? 0)
                  ? tempVideo.fileSize ?? 0
                  : tempData.video.fileSize ?? 0;
              tempArray.push(tempData);
            }
          }
        });
      });

    return tempArray;
  });
  const videoTotalSize = computed<number>(() => {
    return videoList.value.reduce(
      (prev, curr) => prev + (curr.video?.fileSize ?? 0),
      0,
    );
  });

  return {
    videoList,
    videoTotalSize,
  };
}
